import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { InformationPopupPage } from '../../shared/components/information-popup/information-popup.model';
import { InformationPopupActions } from './information-popup.actions';
import { InformationPopupSelectors } from './information-popup.selectors';
import { UserPageSettings } from './information-popup.state';

@Injectable({ providedIn: 'root' })
export class InformationPopupStore {
  allPagesSettings$ = this.store.select(InformationPopupSelectors.getAllPagesSettings());
  loaded$ = this.store.select(InformationPopupSelectors.getIsLoaded());

  constructor(private store: Store) {}

  loadPageSettings(): void {
    this.store.dispatch(InformationPopupActions.loadSettings());
  }

  setPageSettings(page: InformationPopupPage): void {
    this.store.dispatch(InformationPopupActions.setPageSettings({ page }));
  }

  getUserPageSettings(page: InformationPopupPage): Observable<UserPageSettings> {
    return this.store.select(InformationPopupSelectors.getPageSettings(page));
  }
}
